export const categories = [
  { slug: "news", name: "最新动态", icon: "ri-newspaper-line", description: "佐佐木明希的最新新闻与动态更新" },
  { slug: "works", name: "作品精选", icon: "ri-movie-line", description: "影视作品、综艺节目与舞台剧精选" },
  { slug: "photos", name: "写真集锦", icon: "ri-camera-line", description: "精美写真与幕后花絮照片" },
  { slug: "events", name: "活动信息", icon: "ri-calendar-event-line", description: "粉丝见面会、签售会与各类活动安排" },
  { slug: "community", name: "粉丝社区", icon: "ri-heart-line", description: "粉丝互动、讨论区与社区活动" },
];